'use client';

import { Box } from '@chakra-ui/react';
import React, { memo } from 'react';
import HeaderDesktop from './header.desktop';
import HeaderMobile from './header.mobile';
import useDelivery from './_hooks/useDelivery';
import { useTelegramBackButton } from '@/_hooks/useTelegramBackButton';

interface HeaderProps {
  brandLogo?: string | null;
}

const Header: React.FC<HeaderProps> = ({ brandLogo }) => {
  useTelegramBackButton({});
  useDelivery({ enabled: true });

  return (
    <>
      <Box
        top={0}
        zIndex={30}
        position='sticky'
        bg='background.card'
        display={{ base: 'none', lg: 'block' }}
      >
        <HeaderDesktop brandLogo={brandLogo} />
      </Box>
      <Box
        display={{ base: 'block', lg: 'none' }}
        position='sticky'
        py={2}
        top={0}
        bg='background.card'
        color='text'
        zIndex={30}
      >
        <Box pt='var(--tg-content-safe-area-inset-top)'>
          <HeaderMobile />
        </Box>
      </Box>
    </>
  );
};

export default memo(Header);
